









































































































































































































import * as moment from "moment";
import axios from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class HelloWorld extends Vue {
  diffs: any[] = [];

  async mounted() {
    const response = await axios.get(
      "https://crit.zone/assets/army/changelog.json"
    );

    const data = response.data.sort((a: any, b: any) => {
      return b.crawled - a.crawled;
    });

    for (const change of data) {
      const diff = {
        changelog: change,
        diff: null
      };

      const response = await axios.get(`https://crit.zone/${change.path}`);
      diff.diff = response.data;

      this.diffs.push(diff);
    }
  }

  formatDate(unixTimestamp: string) {
    return moment.unix(parseInt(unixTimestamp, 10)).format();
  }
}
